export default __webpack_public_path__ + "static/media/pageBack.e9d83e56.png";